import React from 'react'

import { GeneralDetails as GeneralDetailsDto } from 'core/application/csiDashboard/csiSearch/getProgramDetails'

import Item from 'common/components/dataDisplay/ItemWithoutSpacing'

interface GeneralDetailsProps {
  translate: (key: string) => string
  generalDetails: GeneralDetailsDto
}

const GeneralDetails: React.FC<GeneralDetailsProps> = ({ translate, generalDetails }) => {
  return (
    <div>
      <div>
        <h5>{translate('csi-dashboard.program-details.general-details')}</h5>
      </div>
      <div className="flex flex__space_between">
        <Item
          translate={translate}
          title={translate('csi-dashboard.program-details.primary-admin')}
          text={generalDetails.primaryAdmin}
        />
        <Item
          translate={translate}
          title={translate('csi-dashboard.program-details.primary-admin-email')}
          text={generalDetails.primaryAdminEmail}
        />
        <Item
          translate={translate}
          title={translate('csi-dashboard.program-details.company-main-phone-number')}
          text={generalDetails.primaryAdminPhoneNumber}
        />
        <Item
          translate={translate}
          title={translate('csi-dashboard.program-details.admin-direct-work-phone-number')}
          text={generalDetails.mainPhoneNumber}
        />
      </div>
      <div className="flex flex__space_between mt-32">
        <Item
          translate={translate}
          title={translate('csi-dashboard.program-details.tax-classification')}
          text={generalDetails.taxClassification}
        />
        <Item translate={translate} title={translate('csi-dashboard.program-details.ein')} text={generalDetails.ein} />
        <div></div>
        <div></div>
      </div>
    </div>
  )
}

export default GeneralDetails
